import { render, staticRenderFns } from "./withdrawConfig.vue?vue&type=template&id=017a0632&scoped=true"
import script from "./withdrawConfig.vue?vue&type=script&lang=js"
export * from "./withdrawConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017a0632",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('017a0632')) {
      api.createRecord('017a0632', component.options)
    } else {
      api.reload('017a0632', component.options)
    }
    module.hot.accept("./withdrawConfig.vue?vue&type=template&id=017a0632&scoped=true", function () {
      api.rerender('017a0632', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/withdraw/withdrawConfig.vue"
export default component.exports